export const promocodes = '/promo-codes';
export const promocode = (id: number) => `/promo-codes/${id}`;
